<template>
    <AppMainDialogForm v-model="dialog" :isLoading="isLoading" size='800' :tituloTela="tituloTela" :tooltip="tooltip" 
        @initComponent="initComponent" @saveRegistro="saveRegistro" @cancel="cancel">
        <v-form v-model="isFormValid" ref="form">
            <v-layout row justify-center v-if="registro.idUsuario > 0">
                <v-flex class="item" xs4 md4>
                    <v-text-field :rules="[campoObrigatorio]" v-model.trim="registro.dsUsername"
                        label="UserName" outlined clearable>
                    </v-text-field>
                </v-flex>
                <v-flex class="item" xs7 md7>
                    <v-text-field :rules="[campoObrigatorio]" v-model.trim="registro.nmUsuario"
                        label="Nome" outlined clearable>
                    </v-text-field>
                </v-flex>
            </v-layout>
            <v-layout row justify-center v-else>
                <v-flex class="item" xs4 md4>
                    <v-text-field :rules="[campoObrigatorio]" v-model.trim="registro.dsUsername"
                        label="UserName" outlined clearable>
                    </v-text-field>
                </v-flex>
                <v-flex class="item" xs7 md7>
                    <v-text-field :rules="[campoObrigatorio]" v-model.trim="registro.dsPassword" @click:append="showPass = !showPass"
                        label="Senha" outlined clearable :append-icon="showPass ? 'mdi-eye' : 'mdi-eye-off'" :type="showPass ? 'text' : 'password'">
                    </v-text-field>
                </v-flex>
            </v-layout>
            <v-layout row justify-center v-if="registro.idUsuario == undefined">
                <v-flex class="item" xs11 md11>
                    <v-text-field :rules="[campoObrigatorio]" v-model.trim="registro.nmUsuario"
                        label="Nome" outlined clearable>
                    </v-text-field>
                </v-flex>
            </v-layout>
            <v-layout row justify-center>
                <v-flex class="item" xs4 md4>
                    <v-text-field v-model="registro.nrTelefone" label="Celular" v-mask="['(##)#####-####', '(##)####-####']"
                        outlined clearable>
                    </v-text-field>
                </v-flex>
                <v-flex class="item" xs7 md7>
                    <v-text-field v-model="registro.dsEmail" :rules="[campoEmail]"
                        label="E-mail" outlined clearable>
                    </v-text-field>
                </v-flex>
            </v-layout>
            <v-layout row justify-start pa-0 pl-8 v-if="registro.idUsuario > 0">
                <v-flex class="item" xs3 md5>
                    <v-btn @click="openDialogAlterarSenha" rounded color="#ff542969" >
                        <span> Alterar senha do usuário </span>
                    </v-btn>
                </v-flex>
                <v-flex class="item" xs4 md4>
                    <v-spacer />
                </v-flex>
            </v-layout>
        </v-form>
        <v-layout row justify-center v-if="registro.idUsuario > 0">
            <v-flex sm2 xs2 md1>
                <DialogAlteraSenhaUsuario :dialog="dialogAlterarSenha" :idProdutor="registro.idProdutor" 
                    @openDialog="openDialogAlterarSenha" @closeDialog="closeDialogAlterarSenha" :rec="registro"/>
            </v-flex>
        </v-layout>
    </AppMainDialogForm>
</template>

<script>
    import { campoObrigatorio, campoSelectObrigatorio, campoEmail } from '@/filters/rules'
    import { mask } from 'vue-the-mask'

    import AppMainDialogForm from '@/components/layout/AppMainDialogForm.vue'
    import DialogAlteraSenhaUsuario from '@/components/dialogs/DialogAlteraSenhaUsuario.vue'

    export default {
        components: {
            AppMainDialogForm,
            DialogAlteraSenhaUsuario
        },
        directives: {
            mask,
        },
        data () {
            return {
                tooltip: 'Novo Usuário',
                tituloTela: 'Cadastro de Usuário',
                isFormValid: true,
                isLoading: false,
                isInserting: true,
                registro: {
                    dsEmail: null
                },
                maskCel: ['(##)#####-####'],
                dialogAlterarSenha: false,
                showPass: false,
            }
        },
        computed: {
            urlAPIEstabelecimento() {
                return this.$store.state.urlAPIEstabelecimento
            },
        },
        methods: {
            campoObrigatorio,
            campoSelectObrigatorio,
            campoEmail,
            initComponent() {
                this.$emit('openDialog')
                var usuario = {}
                if (this.rec.idUsuario != undefined)
                {
                    usuario = this.rec
                    this.isInserting = false
                }
                else
                {   
                    if (this.$refs.form != undefined)
                    {
                        this.$refs.form.reset()
                    }
                    this.isInserting = true
                    usuario = {
                        dsEmail: null
                    }
                }
                this.registro = Object.assign({}, usuario)
            },
            saveRegistro() {
                if (this.$refs.form.validate())
                {
                    this.isLoading = true
                    if (this.isInserting)
                    {
                        this.insertRegistro()
                    }
                    else
                    {
                        this.updateRegistro()
                    }
                }
            },
            insertRegistro() {
                this.registro.dsEmail = this.registro.dsEmail == '' ? null : this.registro.dsEmail
                this.registro.cdEstabelecimento = this.idEstabelecimento
                this.$axios.post(this.urlAPIEstabelecimento + 'usuario/', this.registro)
                    .then((response) => {
                        this.$emit('inserted', response.data)
                        this.$emit('closeDialog')
                    })
                    .catch((error) => {
                        this.$store.commit('setSnack', {type: 'error', msg: error})
                    })
                    .finally(() => {
                        this.isLoading = false
                    })
            },
            updateRegistro() {
                this.registro.dsEmail = this.registro.dsEmail == '' ? null : this.registro.dsEmail
                this.$axios.put(this.urlAPIEstabelecimento + 'usuario/' + this.registro.idUsuario, this.registro)
                    .then((response) => {
                        this.$emit('updated', response.data)
                        this.$emit('closeDialog')
                    })
                    .catch((error) => {
                        this.$store.commit('setSnack', {type: 'error', msg: error})
                    })
                    .finally(() => {
                        this.isLoading = false
                    })
            },
            cancel() {
                this.$emit('closeDialog')
            },
            closeDialogAlterarSenha() {
                this.dialogAlterarSenha = false
            },
            openDialogAlterarSenha() {
                this.dialogAlterarSenha = true
            },
        },
        props: {
            idEstabelecimento: Number,
            dialog: {
                type: Boolean,
                default: false
            },
            rec: {
                type: Object,
                default: () => ({})
            },
        },
        watch: {
            'dialog' (newValue, oldValue) {
                if (newValue && !oldValue)
                {
                    this.initComponent()
                }
            }
        }
    }
</script>

<style scoped>
    .item {
        margin: 1px
    }
</style>
